// import Vue from 'vue';
// import VueI18n from 'vue-i18n';
// import getBrowserLocale from './utils/get-browser-locale';
// import { supportedLocalesInclude } from './utils/supported-locales';

// Vue.use(VueI18n);

// function loadLocaleMessages() {
//   const locales = require.context(
//     './locales',

//     true,

//     /[A-Za-z0-9-_,\s]+\.json$/i
//   );

//   const messages = {};

//   locales.keys().forEach((key) => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);

//     if (matched && matched.length > 1) {
//       const locale = matched[1];

//       messages[locale] = locales(key);
//     }
//   });

//   return messages;
// }

// function getStartingLocale() {
//   const browserLocale = getBrowserLocale({ countryCodeOnly: true });
//   if (supportedLocalesInclude(browserLocale)) {
//     return browserLocale;
//   } else {
//     return process.env.VUE_APP_I18N_LOCALE || 'en';
//   }
// }

// export default new VueI18n({
//   // locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   locale: getStartingLocale(),

//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',

//   messages: loadLocaleMessages(),
// });

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import getBrowserLocale from '@/utils/get-browser-locale';
import { supportedLocalesInclude } from './utils/supported-locales';
import {
  getChoiceIndex,
  setDefaultChoiceIndexGet,
} from './utils/choice-index-for-plural';
import dateTimeFormats from '@/locales/date-time-formats';
import numberFormats from '@/locales/number-formats';

Vue.use(VueI18n);

function getStartingLocale() {
  // const browserLocale = getBrowserLocale({ countryCodeOnly: true });
  //
  // if (supportedLocalesInclude(browserLocale)) {
  //   return browserLocale;
  // } else {
  return process.env.VUE_APP_I18N_LOCALE || 'en';
  // }
}

setDefaultChoiceIndexGet(VueI18n.prototype.getChoiceIndex);

VueI18n.prototype.getChoiceIndex = getChoiceIndex;

const startingLocale = getStartingLocale();

const i18n = new VueI18n({
  locale: startingLocale,

  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',

  messages: {},

  dateTimeFormats,

  numberFormats,
});

const loadedLanguages = [];

export function loadLocaleMessagesAsync(locale) {
  if (loadedLanguages.length > 0 && i18n.locale === locale) {
    return Promise.resolve(locale);
  }

  if (loadedLanguages.includes(locale)) {
    i18n.locale = locale;

    return Promise.resolve(locale);
  }

  return import(
    /* webpackChunkName: "locale-[request]" */ `@/locales/${locale}.json`
  ).then((messages) => {
    i18n.setLocaleMessage(locale, messages.default);

    loadedLanguages.push(locale);

    i18n.locale = locale;

    return Promise.resolve(locale);
  });
}

loadLocaleMessagesAsync(startingLocale);

export default i18n;
